import { Suggestions } from '@mint-sdk/api-recommendations';

import type {
  SuggestionChipColors,
  SuggestionHeaderStatus,
  SuggestionSeparateChipStatus,
} from '../types/chips.js';

export const suggestionChipColors: Record<
  SuggestionHeaderStatus | SuggestionSeparateChipStatus,
  SuggestionChipColors
> = {
  [Suggestions.Statuses.ACCEPTED]: 'success',
  [Suggestions.Statuses.ACCEPTING]: 'info',
  [Suggestions.Statuses.REJECTED]: 'warning',
  [Suggestions.Statuses.ERROR]: 'error',
  [Suggestions.Statuses.REWORKING]: 'fuchsia',
  [Suggestions.Statuses.EXPIRED]: 'silver',
  ['ORIGINAL']: 'silver',
  ['REWORKED_HEADLINE']: 'secondary',
  ['REWORKED_CARD']: 'warning',
  ['PUBLISHED']: 'secondary',
  ['READY_FOR_PUBLISHING']: 'royal',
};
